module.exports = __webpack_public_path__ + "assets/webgl/FloorPattern.jpg.etc.0d204c7e.ktx";